import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const SCRUB_SECONDS = 1

export interface CreateFloraScrollTimelineOptions {
  scrollContainer: HTMLElement
  onSmoothedProgress(progress: number): void
  onRawProgress(progress: number): void
  immediate?: boolean
}

export function createFloraScrollTimeline({
  scrollContainer,
  onSmoothedProgress,
  onRawProgress,
  immediate = false,
}: CreateFloraScrollTimelineOptions): () => void {
  const smoothedProgress = { value: 0 }

  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: scrollContainer,
      start: 'top top',
      end: 'bottom bottom',
      scrub: immediate ? true : SCRUB_SECONDS,
      onUpdate(self) {
        onRawProgress(self.progress)
      },
    },
  })

  timeline.to(smoothedProgress, {
    value: 1,
    ease: 'none',
    onUpdate() {
      onSmoothedProgress(smoothedProgress.value)
    },
  })

  return () => {
    timeline.scrollTrigger?.kill()
    timeline.kill()
  }
}
